<template>
	<div :class="shovValidate ? 'mainContainer show' : 'mainContainer'">
		<div :class="valid ? 'dropdownWrapper complete' : 'dropdownWrapper incomplete'">
			<div :class='opened ? "v_dropdown-write opened" : "v_dropdown-write"'>
		<span class="focus-bg"></span>
		<!-- <div class="text">{{placeholder}}:</div> -->
		<input type="text" v-model='filter' :placeholder="placeholder" @focus='open'>
		<!-- {{filtered.length}} - {{filter}} -->

		<div class="wtf" @click='wtf'></div>

		<div :class='opened ? "options active" : "options"'>
			<div class="overflow">
				<template v-if='filtered.length'>
					<div
					 	v-for='opt in filtered'
						:class='active === opt.text ? "opt active" : "opt"'
						@click='select(opt.text, opt.value)'>

						{{opt.text}}
					</div>
				</template>
				<template v-else>
					<div class="null"></div>
				</template>
			</div>
		</div>
	</div>
		</div>
	</div>
</template>

<script>
module.exports = {
	props: [
		'name', 'options', 'placeholder'
	],

	data() {
		return {
			active: '',
			filter: '',
			opened: false,
			value: '',
			valid: false,
			shovValidate: false
		}
	},

	computed: {
		filtered() {
			return this.options.filter(opt => {
				return opt.text.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1
			})
		}
	},

	watch: {
		value() {
			this.$emit('changed', {
				[this.name]: this.active
			}, this.value);
		}
	},

	methods: {
		select(txt, val) {
			this.active = txt;
			this.filter = txt;
			this.opened = false;
			this.value = val;

			this.valid = true;
		},

		wtf() {
			if(this.opened) {
				this.opened = false;
				this.filter = this.active;
			}
			else {
				this.$el.querySelector('input').focus();
			}
		},

		open() {
			this.filter = '';
			this.opened = true;
		},

		setActive(opt) {
			this.active = opt.value;
			this.opened = false;
			this.text = opt.text;

			this.$emit('changed', {
				name: this.name,
				value: this.active
			});
			this.valid = true;
			this.shovValidate = true;
		},

		validate() {
			this.shovValidate = true;
			// console.log('this.shovValidate ss');
		}
	},

	mounted() {

		this.active = this.options[0].text;
		this.filter = this.options[0].text;
		this.value = this.options[0].value;

		document.addEventListener('click', e => {
			if(!$(e.target).closest($(this.$el)).length) {
				this.opened = false;
				this.filter = this.active;
			}
		})
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";
	.focus-bg{
		&:before, &:after{
			content: "";
			position: absolute;
			left: 50%;
			top: 50%;
			width: 0;
			height: 0;
			background-color: rgba(#ededed, .15);
			transition: 0.3s;
			z-index: -1;
		}
		&:after{
			left: auto;
			right: 50%;
			top: auto;
			bottom: 50%;
		}
	}
	.dropdownWrapper.complete{
		&.after{
			display: none;
		}
	}
	.v_dropdown-write {
		height: 50px;
		border: 1px solid #aabcc8;
		border-radius: 25px;
		font-size: 15px;
		color: #282828;
		display: flex;
		align-items: center;
		padding: 0 19px;
		position: relative;
		background-color: #fff;

		&:after {
			content: '';
			display: block;
			width: 12px;
			height: 7px;
			position: absolute;
			top: calc(50% - 3px);
			right: 19px;
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover!important;
			background: url('#{$imgPathSCSS}arrLL.png');
			@include single-transition;
			z-index: 1;
		}



		.wtf {
			display: block;
			width: 12px;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 10px;
			z-index: 2;
			// background-color: rgba(red, .2);
			cursor: pointer;
		}

		&.opened {
			&:after {
				@include rotate(180deg);
			}
			.focus-bg{
				&:before{
					transition: 0.3s;
					width: 50%;
					left: 0;
					top: 0;
					height: 100%;
					z-index: 0;
				}
				&:after{
					transition: 0.3s;
					width: 50%;
					height: 100%;
					bottom: 0;
					right: 0;
					z-index: 0;
				}
			}
		}

		.text {
			margin: 0 5px 0 0;
		}

		input {
			align-self: stretch;
			border: none;
			font-size: 16px;
			color: #282828;
			font-weight: 500;
		}

		.options {
			position: absolute;
			top: calc(100% + 15px);
			left: 0;
			width: 100%;
			background-color: #fff;
			border-radius: 6px;
			z-index: 3;
			border: 1px solid #EFEFEF;
			padding: 10px 0 10px 10px;
			box-shadow: 0px 5px 10px 0px rgba(#000, 0.05);
			@include single-transition;
			opacity: 0;
			@include pointer-events(none);
			@include translateY(10px);

			&.active {
				opacity: 1;
				@include pointer-events(auto);
				@include translateY(0px);
			}

			&:before {
				content: '';
				display: block;
				width: 19px;
				height: 10px;
				// background: url('#{$imgPathSCSS}dda.png') no-repeat center;
				position: absolute;
				right: 10px;
				bottom: calc(100% - 1px);
			}

			.overflow {
				max-height: 200px;
				overflow: auto;
				padding: 0 10px 0 0;
			}

			.null {
				&:after {
					@include fa($fa-frown-o);
					font-size: 20px;
				}
			}

			.opt {
				color: #282828;
				font-size: 16px;
				font-weight: 500;
				line-height: 17px;
				border: 1px solid #fff;
				border-radius: 8px;
				margin: 0 0 2px;
				padding: 12px 10px 10px;
				cursor: pointer;
				@include single-transition;

				&:hover {
					border-color: #ACB1B5;
				}

				&.active {
					border-color: #2967a7 !important;
					color: #2967a7;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// dropdown-write.vue?76bc7356